import(/* webpackMode: "eager" */ "/workspace/web/app/embed/layout.tsx");
